// ListaDetallePage.jsx
import React, { useState } from 'react';
import EditarLista from './editarlista';
import { alpha } from '@mui/material/styles';
import AppNavbar from '../../../components/AppNavbar';
import Header from '../../../components/Header';
import SideMenu from '../../../components/SideMenu';
import AppTheme from '../../../shared-theme/AppTheme';
import {
    chartsCustomizations,
    dataGridCustomizations,
    datePickersCustomizations,
    treeViewCustomizations,
  } from '../../dashboard/theme/customizations';
import { Box, CssBaseline, Stack } from '@mui/material';
  
const xThemeComponents = {
...chartsCustomizations,
...dataGridCustomizations,
...datePickersCustomizations,
...treeViewCustomizations,
};

const mockLista = {
  nombre: 'Lista Promocional',
  tipo: 'sucursal',
  sucursalOCliente: 'Sucursal Santiago',
  productos: [
    { id: 1, nombre: 'Producto A', precio: 120 },
    { id: 2, nombre: 'Producto B', precio: 150 },
  ],
  activa: true,
};

const mockProductosDisponibles = [
  { id: 1, nombre: 'Producto A' },
  { id: 2, nombre: 'Producto B' },
  { id: 3, nombre: 'Producto C' },
];

const ListaDetallePage = (props) => {
  const [lista, setLista] = useState(mockLista);

  const handleGuardar = () => {
    console.log('Guardar lista actualizada:', lista);
    // Aquí podrías enviar a la API
  };

  return (
    <AppTheme {...props} themeComponents={xThemeComponents}>
        <CssBaseline enableColorScheme />
        <Box sx={{ display: 'flex' }}>
            <SideMenu />
            <AppNavbar />
            {/* Main content */}
            <Box
            component="main"
            sx={(theme) => ({
                flexGrow: 1,
                backgroundColor: theme.vars
                ? `rgba(${theme.vars.palette.background.defaultChannel} / 1)`
                : alpha(theme.palette.background.default, 1),
                overflow: 'auto',
            })}
            >
            <Stack
                spacing={2}
                sx={{
                alignItems: 'center',
                mx: 3,
                pb: 5,
                mt: { xs: 8, md: 0 },
                }}
            >
                <Header parent={"Logistica y Almacenes"} child={"Lista de Precios"}/>
                <EditarLista
                lista={lista}
                setLista={setLista}
                onGuardar={handleGuardar}
                productosDisponibles={mockProductosDisponibles}

                />
            </Stack>
        </Box>
        </Box>
    </AppTheme>
  );
};

export default ListaDetallePage;
